export const normalizeNullValues = <T>(val?: T): T | undefined => (val === null ? undefined : val);
